import { createAction, createReducer } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'

export const addNotice = createAction('ADD_NOTICE')
export const removeNotice = createAction('REMOVE_NOTICE')

export default createReducer([], builder => {
  builder
    .addCase(addNotice, (state, action) => {
      const id = uuidv4()

      state.push({
        id,
        text: action.payload.message || action.payload,
        type: action.payload.type || 'success'
      })
    })
    .addCase(removeNotice, (state, action) =>
      state.filter(n => n.id !== action.payload)
    )
})
